module.exports = __webpack_public_path__ + "img/图片3.17dedf96.png";